module.exports = __webpack_public_path__ + "static/media/pattern.795db379.jpg";